'use client';

const BrandDivider = ({ align = 'center' }) => {
  return (
    <div
      className={`h-1 w-12 block mt-6 ${
        align === 'left' ? 'mr-auto ml-0' : align === 'right' ? 'ml-auto mr-0' : 'mx-auto'
      } bg-brand-300`}
    />
  );
};

export default BrandDivider;
